(() => {
  'use strict';
  const root = document.querySelector('[data-st-eu-quantity-wrapper]');
  if (!root || root.dataset.quantityInitialized === 'true') return;
  const input = root.querySelector('product-quantity-selector input[name="quantity"]');
  if (!input) return;
  const packSize = Number.parseInt(root.dataset.packQuantity || '', 10);
  if (!Number.isInteger(packSize) || packSize <= 0) return; // Standard product: keep native UI
  const nativeWrapper = input.closest('product-quantity-selector');
  if (!nativeWrapper || !nativeWrapper.parentNode) return;
  const lang = (document.documentElement.lang || 'fr').slice(0, 2);
  const locales = {
    fr: {quantity:'Quantité',pack:'paquet',packs:'paquets',tiles:'tuiles'},
    en: {quantity:'Quantity',pack:'pack',packs:'packs',tiles:'tiles'},
    de: {quantity:'Menge',pack:'Packung',packs:'Packungen',tiles:'Fliesen'},
    it: {quantity:'Quantità',pack:'confezione',packs:'confezioni',tiles:'piastrelle'},
    nl: {quantity:'Aantal',pack:'pak',packs:'pakken',tiles:'tegels'}
  };
  const words = locales[lang] || locales.en;
  const ui = document.createElement('div');
  ui.className = 'st-eu-quantity-ui';
  ui.innerHTML = `<span class="st-eu-quantity-label">${words.quantity}</span><div class="st-eu-quantity-control"><button type="button" data-minus aria-label="−">−</button><span class="st-eu-quantity-value"><span data-packs aria-live="polite"></span><span class="st-eu-tiles-count" data-tiles></span></span><button type="button" data-plus aria-label="+">+</button></div>`;
  nativeWrapper.parentNode.insertBefore(ui,nativeWrapper);
  nativeWrapper.parentNode.classList.add('st-eu-quantity-row');
  // Keep the original Shopify quantity input for FormData/cart handling.
  // Display none only affects the selector, not its form submission.
  nativeWrapper.style.display = 'none';
  function qty(){const n=Number.parseInt(input.value,10);return Number.isInteger(n)&&n>0?n:1;}
  function max(){const n=Number.parseInt(input.max,10);return Number.isInteger(n)&&n>0?n:Infinity;}
  function render(){const n=qty();ui.querySelector('[data-packs]').textContent=`${n} ${n===1?words.pack:words.packs}`;ui.querySelector('[data-tiles]').textContent=`${n*packSize} ${words.tiles}`;ui.querySelector('[data-minus]').disabled=n<=1;ui.querySelector('[data-plus]').disabled=n>=max();}
  function set(n){const next=Math.min(max(),Math.max(1,n));input.value=String(next);input.dispatchEvent(new Event('input',{bubbles:true}));input.dispatchEvent(new Event('change',{bubbles:true}));render();}
  ui.querySelector('[data-minus]').addEventListener('click',()=>set(qty()-1));
  ui.querySelector('[data-plus]').addEventListener('click',()=>set(qty()+1));
  input.addEventListener('change',render);
  input.addEventListener('input',render);
  root.dataset.quantityInitialized='true';
  render();
})();
